"use client";
import { FC, MouseEvent, useEffect, useRef, useState } from "react";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import { cn } from "@/lib/utils";
import Link from "next/link";
import dynamic from "next/dynamic";

//import { ApplyModal } from "./apply-modal";
import { siteNavMap, NavType, siteConfig } from "@/config/site";
import NetworkSvg from "@/public/icon/network";
import SafeSvg from "@/public/icon/safe";
import Svg5g from "@/public/icon/5g";
import TelSvg from "@/public/icon/tel";
import PeopleSvg from "@/public/icon/people";
import ArrowSvg from "@/public/icon/arrow";
import MenuSvg from "@/public/icon/menu";
import { Divider, Drawer } from "antd";
import { productMenuList } from "@/config/productInfo";
import { solutionMenuList } from "@/config/solutionInfo";
import BigMenu from "./bigMenu";

const ApplyModal = dynamic(() => import("./apply-modal"));
const DrawerComp = dynamic(() => import("./drawer"));

const menuList = ["首页", "产品", "解决方案", "服务与支撑", "关于我们"];

type IntroType = {
  title: string;
  href: string;
}[];

const introList = siteNavMap[NavType.intro].children!;
// const productList = siteNavMap[NavType.product].children!;

export const SiteHeader: FC = () => {
  const path = usePathname();
  const router = useRouter();

  const [isTop, setIsTop] = useState(true);
  const headerRef = useRef<HTMLElement>(null);
  const scrollFunction = () => {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;

    setIsTop(!scrollTop);
  };
  useEffect(() => {
    scrollFunction();
    window.addEventListener("scroll", scrollFunction);
    return () => {
      window.removeEventListener("scroll", scrollFunction);
    };
  }, []);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const isCurPath = (href: string) => {
    if (path === href) return true;
    else if (path.includes(href) && href != "/") return true;
    else return false;
  };

  const [curMouseEnterIdx, setCurMouseEnterIdx] = useState(0);

  const handlePush = (e: any, href: string) => {
    e.preventDefault();
    router.push(href);
  };

  const handleApply = (e: any) => {
    setIsModalOpen(true);
  };

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <header
      className={cn(
        "sticky top-0 z-40 w-full transition-[background] duration-[1500ms] ease-[cubic-bezier(0,0.96,0.23,0.76)]",
        isTop ? "bg-transparent" : "bg-white shadow-lg",
        "md:min-w-[1200px]",
        path === "/intro/contactus" && "bg-[#333333]"
      )}
      ref={headerRef}
    >
      <div className="group/nav container relative flex items-center h-[3rem] px-6 md:px-0">
        <div className="flex flex-1 items-center gap-12">
          <Link href="/">
            <Image
              src={
                isTop
                  ? "/home/topnav/top-logo1.png"
                  : "/home/topnav/top-logo2.png"
              }
              className="w-28 md:w-32 h-full cursor-pointer"
              alt="Wild Landscape"
              width="261"
              height="57"
              quality={100}
            />
          </Link>
          <nav className="hidden md:block">
            <ol className="flex flex-row">
              {siteConfig["mainNav"].map((menu, idx) => (
                <li
                  key={idx}
                  className="group/item relative px-6"
                  onMouseEnter={() => setCurMouseEnterIdx(idx)}
                >
                  <div
                    className={cn(
                      "text-sm  h-[3rem] leading-[3rem] cursor-pointer ",
                      isTop ? "text-white" : "text-black",
                      isCurPath(menu.key) && !isTop && "text-[#004EA2]",
                      isCurPath(menu.key) && "font-bold"
                    )}
                  >
                    <Link href={menu.href} className="cursor-pointer">
                      {menu.title}
                    </Link>
                  </div>
                  <div
                    className={cn(
                      "tag w-full h-0.5",
                      isCurPath(menu.key) ? "visible" : "invisible",
                      isTop ? "bg-white" : "bg-[#004EA2]"
                    )}
                  ></div>

                  {idx === 4 ? (
                    <div
                      className={cn(
                        "absolute bottom-0 translate-y-[100%] hidden translate-x-[-50%] left-[50%]",
                        "group-hover/item:block"
                      )}
                    >
                      <div className="flex flex-col space-y-3 px-9 py-8  rounded-lg bg-[rgba(255,255,255,0.9)]">
                        <h4 className="space-x-2 flex items-center">
                          <PeopleSvg className="w-6 h-6" />
                          <span className="text-[#333333] ">关于我们</span>
                        </h4>
                        <hr className="border-none w-28 h-px bg-[#999999]" />
                        <ol className="flex flex-col space-y-3.5">
                          {(introList as IntroType).map(
                            ({ title, href }, idx) => (
                              <li
                                className={cn(
                                  "text-[#333333] text-[13px] hover:text-[#004EA2]",
                                  path === href && "text-[#004EA2]"
                                )}
                                key={idx}
                              >
                                <Link href={href}>{title}</Link>
                              </li>
                            )
                          )}
                        </ol>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </li>
              ))}
            </ol>
          </nav>
        </div>
        {/**产品菜单 */}
        <BigMenu
          curPath={path}
          curMouseEnterIdx={curMouseEnterIdx}
          menuList={productMenuList}
          idx={1}
        />
        {/**解决方案菜单 */}
        <BigMenu
          curPath={path}
          curMouseEnterIdx={curMouseEnterIdx}
          menuList={solutionMenuList}
          idx={2}
        />
        {/**右侧 */}
        <div
          className="flex flex-row items-center space-x-7"
          onMouseEnter={() => setCurMouseEnterIdx(-1)}
        >
          <div className="space-x-3.5 flex-row items-center hidden md:flex">
            <TelSvg
              className="w-[1.625rem] h-[1.625rem]"
              color={isTop ? "white" : "#004EA2"}
            />
            <span
              className={cn("text-xl", isTop ? "text-white" : "text-[#004EA2]")}
            >
              400-008-5020
            </span>
            {/* <hr
              className={cn(
                "rotate-90 w-5 h-px border-none",
                isTop ? "bg-white" : "bg-neutral-400"
              )}
            /> */}
            <Divider
              type="vertical"
              className={cn(isTop ? "bg-white" : "bg-neutral-400")}
            />
            <span
              className={cn("text-sm", isTop ? "text-white" : "text-black")}
            >
              网站支持IPv6
            </span>
          </div>
          <div
            className="inline-block text-xs md:text-sm bg-[#3CB149] rounded-xl px-3 text-center cursor-pointer text-white
            h-[1.5rem] !leading-[1.5rem]
            "
            onClick={(e) => handleApply(e)}
          >
            申请使用
          </div>
          <MenuSvg
            className="w-6 h-6 block md:hidden"
            color={isTop ? "white" : "#004EA2"}
            onClick={() => setIsDrawerOpen(true)}
          />
        </div>
      </div>
      {isModalOpen && (
        <ApplyModal isModalOpen={isModalOpen} handleModal={setIsModalOpen} />
      )}

      {isDrawerOpen && (
        <DrawerComp
          isDrawerOpen={isDrawerOpen}
          handleDrawer={setIsDrawerOpen}
        />
      )}

      {/* <Drawer
        title=<header>
          <div className="flex justify-between item-center">
            <Image
              src="/home/topnav/top-logo1.png"
              className="w-36 h-full"
              alt="Wild Landscape"
              width="0"
              height="0"
               
            />
            <TelSvg
              className="w-7 h-7 block md:hidden"
              color={isTop ? "white" : "#004EA2"}
              onClick={onClose}
            />
          </div>
        </header>
        headerStyle={{ borderBottom: 0, padding: 0 }}
        bodyStyle={{ padding: 0 }}
        placement="left"
        closable={false}
        onClose={onClose}
        open={open}
        width="100%"
        className="!bg-[#333333] p-6"
      >
        <div className="text-white divide-y divide-[rgba(255,255,255,0.19)]">
          <details >
            <summary className="list-none">
              <div className="flex justify-between py-3">
                <p>首页</p>
                <TelSvg className="w-5 h-5" />
              </div>
            </summary>
            123321321
          </details>
          <div className="">
            <details>
              <summary className="list-none">
                <div className="flex justify-between py-3">
                  <p>产品</p>
                  <TelSvg className="w-5 h-5" />
                </div>
              </summary>
              <details>
                <summary className="list-none">
                  <div className="flex justify-between py-3">
                    <p>安全</p>
                    <TelSvg className="w-5 h-5" />
                  </div>
                </summary>
                123321321
              </details>
            </details>
          </div>
        </div>
      </Drawer> */}
    </header>
  );
};
